import { render, staticRenderFns } from "./InlineColorPicker.vue?vue&type=template&id=b359e528&"
import script from "./InlineColorPicker.vue?vue&type=script&lang=js&"
export * from "./InlineColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./InlineColorPicker.vue?vue&type=style&index=0&id=b359e528&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports